import { moduleFactory } from "@/factories/module";
import {
  _compactStringForLogging,
  _compactTitleForLogging,
} from "@/modules/string/compact-for-logging";
import { _generateIntegerHashForString } from "@/modules/string/generateIntegerHash";
import { toOxfordComma } from "@/modules/string/to-oxford-comma";

export const stringModule = moduleFactory.create({
  compactForLogging: _compactStringForLogging,
  compactTitleForLogging: _compactTitleForLogging,
  generateIntegerHash: _generateIntegerHashForString,
  toOxfordComma: toOxfordComma,
});
